import { sagwClient } from './clients';
import { TimeSlotResponseDto } from './dtos/timeslot';
import { dtoToTimeSlotResponse, timeslotRequestToDto } from './transformers/timeslot';
import { TimeSlotRequest, TimeSlotResponse } from './models/timeslot';

export const fetchTimeslots = async (request: TimeSlotRequest): Promise<TimeSlotResponse> => {
  return sagwClient
    .post<TimeSlotResponseDto>('/mot/user/timeslots', timeslotRequestToDto(request))
    .then(dtoToTimeSlotResponse);
};
